import {
  MonitorPlay,
  PlayCircle,
  Timer,
  PieChart,
  FileText,
  MessageSquare,
  BookOpen,
} from "lucide-react";

const offerings = [
  { icon: MonitorPlay, text: "Live interactive classes" },
  { icon: PlayCircle, text: "Recorded session access" },
  { icon: Timer, text: "Weekly timed mock tests" },
  { icon: PieChart, text: "Section-wise analysis sessions" },
  { icon: FileText, text: "Personalized strategy review" },
  { icon: MessageSquare, text: "Direct doubt support" },
  { icon: BookOpen, text: "Study materials and notes" },
];

export default function OfferingsSection() {
  return (
    <section
      id="offerings"
      data-testid="offerings-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left */}
          <div className="lg:col-span-5">
            <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
              Inclusions
            </span>
            <h2
              data-testid="offerings-title"
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
            >
              What You Get
            </h2>
            <p className="font-body text-base text-zinc-500 leading-relaxed mt-5 max-w-sm">
              Everything you need for structured, focused CLAT preparation under
              expert guidance.
            </p>
          </div>

          {/* Right */}
          <div className="lg:col-span-7">
            <div className="space-y-4">
              {offerings.map((item, idx) => (
                <div
                  key={idx}
                  data-testid={`offering-item-${idx}`}
                  className="flex items-center gap-4 p-4 rounded-xl hover:bg-orange-50/50 transition-colors group"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
                    <item.icon
                      size={18}
                      strokeWidth={1.5}
                      className="text-orange-600"
                    />
                  </div>
                  <span className="font-body text-base md:text-lg text-zinc-700 font-medium">
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
